import {
    Accordion,
    Text,
    TextTag,
    TokenTextAppearance,
} from '@volkswagen-onehub/components-core'
import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import {
    eventEnvironmentCommon,
    eventInfoCommon,
    TrackingAction,
    trackingData,
    trackingEvent,
} from '../../shared/trackingServiceHelper'
import {useSelector} from 'react-redux'
import {RootState} from '../rootReducer'

const StyledAccordion = styled(Accordion)`
    > div {
        align-items: center;
    }
`

interface AccordionWrapperProps {
    headline: string
    content: string
    isOpen: boolean
    contentId: string
}

export function AccordionWrapper(
    props: AccordionWrapperProps
): React.JSX.Element {
    const {t} = useTranslation('fa-listini')
    const [accordion, showAccordion] = useState(props.isOpen)
    const priceList = useSelector(
        (state: RootState) => state.configurationPriceList.priceList
    )
    const featureAppVariant = priceList + ' ' + trackingData.APP_VARIANT

    return (
        <StyledAccordion
            id={props.headline}
            headline={
                <Text
                    tag={TextTag.span}
                    appearance={TokenTextAppearance.headline100}
                    bold
                >
                    {props.headline.toUpperCase()}
                </Text>
            }
            isOpen={accordion}
            onClick={() => {
                showAccordion(!accordion)

                if (accordion) {
                    trackingEvent(
                        TrackingAction.VW_BASIC_ACCORDION_CLOSE_CLICK,
                        {
                            eventInfo: {
                                ...eventInfoCommon,
                                contentId: props.contentId,
                            },
                            environment: {
                                ...eventEnvironmentCommon(featureAppVariant),
                            },
                            link: {
                                name: props.headline,
                                url: window.location.href,
                            },
                            accordion: {
                                groupItemName: props.headline,
                            },
                        }
                    )
                } else {
                    trackingEvent(
                        TrackingAction.VW_BASIC_ACCORDION_OPEN_CLICK,
                        {
                            eventInfo: {
                                ...eventInfoCommon,
                                contentId: props.contentId,
                            },
                            environment: {
                                ...eventEnvironmentCommon(featureAppVariant),
                            },
                            link: {
                                name: props.headline,
                                url: window.location.href,
                            },
                            accordion: {
                                groupItemName: props.headline,
                                groupItemState: trackingData.ACCORDION_OPEN,
                            },
                        }
                    )
                }
            }}
        >
            <span
                dangerouslySetInnerHTML={{
                    __html: t(props.content),
                }}
            />
        </StyledAccordion>
    )
}
